import * as Schema from "effect/Schema";

export const ApplicationReleaseUpdateSchema = Schema.Struct({
  version: Schema.String,
  releaseCommit: Schema.String,
  /** The release's GitHub Release page (ADR-0131). */
  url: Schema.String,
});
export type ApplicationReleaseUpdate = typeof ApplicationReleaseUpdateSchema.Type;

/**
 * `connect-github` and `reconnect-github` are gone: the Application Release Check reads the
 * Application Release Index anonymously and has no connection to prompt for (ADR-0104). What
 * replaced them is nothing — an unreachable index is `check-failed`, which is what it always
 * meant, and `up-to-date` is reachable only after a check succeeded and found nothing newer.
 */
export const ApplicationReleaseCheckStateSchema = Schema.Union([
  Schema.Struct({ phase: Schema.Literal("disabled") }),
  Schema.Struct({ phase: Schema.Literal("checking") }),
  Schema.Struct({ phase: Schema.Literal("up-to-date") }),
  Schema.Struct({
    phase: Schema.Literal("update-available"),
    release: ApplicationReleaseUpdateSchema,
  }),
  Schema.Struct({ phase: Schema.Literal("check-failed") }),
  Schema.Struct({ phase: Schema.Literal("release-data-invalid") }),
]);
export type ApplicationReleaseCheckState = typeof ApplicationReleaseCheckStateSchema.Type;

export const ApplicationReleaseCheckStatusSchema = Schema.Struct({
  currentVersion: Schema.String,
  enabled: Schema.Boolean,
  lastCheckedAt: Schema.NullOr(Schema.Int),
  stale: Schema.Boolean,
  state: ApplicationReleaseCheckStateSchema,
});
export type ApplicationReleaseCheckStatus = typeof ApplicationReleaseCheckStatusSchema.Type;

export interface DesktopApplicationReleaseBridge {
  getStatus: () => Promise<ApplicationReleaseCheckStatus>;
  checkNow: () => Promise<ApplicationReleaseCheckStatus>;
  setEnabled: (enabled: boolean) => Promise<ApplicationReleaseCheckStatus>;
  openAvailableRelease: () => Promise<boolean>;
}
